module.exports = __webpack_public_path__ + "static/media/bluedot.8d0a5f62.svg";